import Vue from 'vue';
import Router from 'vue-router'; // https://router.vuejs.org/zh/
import Layout from '../views/layout/Layout';

Vue.use(Router);

export const constantRouterMap = [{
        path: '/planCenter',
        component: Layout,
        name: 'PlanCenter',
        children: [{
                path: '/planCenter/planList',
                name: 'planList',
                component: () => import('@/views/planCenter/planList')
            },
            {
                path: '/planCenter/topsheet',
                name: 'topsheet',
                component: () => import('@/views/planCenter/topsheet')
            },
            {
                path: '/planCenter/dup-checkList',
                name: 'dup-checkList',
                component: () => import('@/views/planCenter/dup-checkList')
            }
        ]
    },
    {
        path: '/login',
        component: () => import('@/views/login'),
        name: 'login',
        hidden: true
    },
    {
        path: '/logout',
        component: () => import('@/views/logout'),
        name: 'logout',
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        name: 'My',
        redirect: sessionStorage.getItem('token') !== null ?
            '/planCenter/planList' : '/login',
        children: [{
                path: '/my/myList',
                name: 'myList',
                component: () => import('@/views/my/myList')
            },
            {
                path: '/my/approvalList',
                name: 'approvalList',
                component: () => import('@/views/my/approvalList')
            },
            {
                path: '/my/planTemplate/distribution',
                name: 'Distribution',
                component: () => import('@/views/my/planTemplate/distribution')
            },
            {
                path: '/my/planTemplate/promotion',
                name: 'Promotion',
                component: () => import('@/views/my/planTemplate/promotion')
            },
            {
                path: '/my/planTemplate/media',
                name: 'Media',
                component: () => import('@/views/my/planTemplate/media')
            },
            {
                path: '/my/planTemplate/sales',
                name: 'Sales Fundamental',
                component: () => import('@/views/my/planTemplate/sales')
            },
            {
                path: '/my/planTemplate/roi',
                name: 'BOT-ROI',
                component: () => import('@/views/my/planTemplate/roi')
            },
            {
                path: '/my/planTemplate/pome',
                name: 'BOT-DTC POME',
                component: () => import('@/views/my/planTemplate/pome')
            },
            {
                path: '/my/planTemplate/price',
                name: 'Pricing Sizing',
                component: () => import('@/views/my/planTemplate/price')
            },
            {
                path: '/my/planTemplate/ecommerce',
                name: 'Ecommerce',
                component: () => import('@/views/my/planTemplate/ecommerce')
            }
        ]
    },
    {
        path: '/accessControl',
        component: Layout,
        name: 'AccessControl',
        children: [{
            path: '/accessControl/userList',
            name: 'userList',
            component: () => import('@/views/accessControl/userList')
        }]
    },
    {
        path: '/masterData',
        component: Layout,
        name: 'MasterData',
        children: [{
                path: '/masterData/factbook',
                name: 'factbook',
                component: () => import('@/views/masterData/factbook')
            },
            {
                path: '/masterData/shipment',
                name: 'shipment',
                component: () => import('@/views/masterData/shipment')
            },
            {
                path: '/masterData/sellout',
                name: 'sellout',
                component: () => import('@/views/masterData/sellout')
            },
            {
                path: '/masterData/mapping',
                name: 'mapping',
                component: () => import('@/views/masterData/mapping')
            },
            {
                path: '/masterData/product',
                name: 'product',
                component: () => import('@/views/masterData/product')
            }
        ]
    },
    {
        path: '/404',
        component: () => import('@/views/404'),
        hidden: true
    }
];

export default new Router({
    routes: constantRouterMap,
    // mode: 'hash'
    mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js